var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiddenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12,6a9.77,9.77,0,0,1,8.82,5.5,9.44,9.44,0,0,1-2.41,3.12L19.82,16A11.76,11.76,0,0,0,23,11.47,11.83,11.83,0,0,0,8.36,4.54L10,6.2A9.41,9.41,0,0,1,12,6ZM10.93,7.11,13,9.18a2.5,2.5,0,0,1,1.28,1.28l2.07,2.07a4.68,4.68,0,0,0,.14-1.07A4.49,4.49,0,0,0,12,7,4.24,4.24,0,0,0,10.93,7.11ZM2,3.84,4.69,6.52a11.74,11.74,0,0,0-3.69,5A11.81,11.81,0,0,0,12,19a11.93,11.93,0,0,0,4.32-.81l3.42,3.42,1.41-1.41L3.42,2.42Zm7.5,7.5L12.12,14,12,14a2.5,2.5,0,0,1-2.5-2.5C9.5,11.42,9.51,11.39,9.51,11.34Zm-3.4-3.4L7.86,9.69a4.6,4.6,0,0,0-.36,1.78,4.51,4.51,0,0,0,6.27,4.14l1,1A10.43,10.43,0,0,1,12,17a9.77,9.77,0,0,1-8.82-5.5A9.9,9.9,0,0,1,6.11,7.94Z",
    style: {
      fill: "#77828e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenIcon);
export default __webpack_public_path__ + "static/media/hidden_icon.8e5f381843cab6845f57f3b6bbf7ec13.svg";
export { ForwardRef as ReactComponent };